import { render, staticRenderFns } from "./AccreditProof.vue?vue&type=template&id=ffb5a73c&"
import script from "./AccreditProof.ts?vue&type=script&lang=ts&"
export * from "./AccreditProof.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports